import { z } from "zod";

export const companyAddressSchema = z.object({
  line1: z.string().trim().min(1, "Enter address line 1"),
  // line2 and state are optional address parts; allow empty.
  line2: z.string().trim(),
  city: z.string().trim().min(1, "Enter the city"),
  postalCode: z.string().trim().min(1, "Enter the postal code"),
  state: z.string().trim(),
  // ISO 3166-1 alpha-2 code chosen from the country dropdown (CountrySelect).
  country: z.string().trim().min(1, "Select a country"),
});

export type CompanyAddressValues = z.infer<typeof companyAddressSchema>;
